import styled from "styled-components";
import Loading from "components/Loading";

interface IInputYesNo {
  focus?: boolean;
}

export const InputArea = styled.div<IInputYesNo>`
  display: flex;
  align-items: center;
  margin-top: 10px;
  
  input{
    height: 32px;
    width: 110px;
    background-color: #ffffff;
  }

  .inputBtn{
    margin-left: 6px;
    cursor: ${props => props.onFocus ? 'pointer' : ''};;
  }
`;

export const ContainerInput = styled.div`
  position: relative;

  > .sk-circle {
    z-index: 9999;
    position: absolute;
    left: calc(50% - 5px);
  }
`;

export const Loader = styled(Loading).attrs({
  size: 14
})``;